import CheckCategories from '@/components/CheckCategories';
import { ApplicationState } from '@/store';
import { completeOnboardRequest } from '@/store/onboard/actions';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import './style.scss';

const SelectionInterests: React.FC = () => {
    const { strings, selectedCategories } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        selectedCategories: state.categories.data.selectedCategories,
    }));

    const dispatch = useDispatch();

    const history = useHistory();

    const complete = () => {
        dispatch(completeOnboardRequest(selectedCategories));
        history.push({
            pathname: '/onboardingAcknowledgement',
            state: { canRedirect: false },
        });
    };

    return (
        <div className="selection-interests">
            <div className="selection-header">
                <span className="title">{strings.ONBOARDING.TOPICS_OF_INTEREST}</span>
                <span className="subtitle">{strings.ONBOARDING.TOPICS_OF_INTEREST_DESCRIPTION}</span>
            </div>

            <CheckCategories backgroundColorTransparent saveOnSelect={true} />

            <div className="button-container">
                <div className="bg-cinza"></div>
                <button className="btn btn-primary btn-sm" disabled={selectedCategories && selectedCategories.length === 0} onClick={complete}>
                    <span className="button-text">{strings.UNDERSTAND}!</span>
                </button>
            </div>
        </div>
    );
};

export default SelectionInterests;
